module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.df115f01.webp";